import { Expose, Type } from 'class-transformer';

import { SnModel } from '@lib/common/models';

import { SnNotificationGroup } from '../notification-group';
import { SnTeam } from '../team';
import { SnUser } from '../user';

export class SnRecordingRetentionSchedule extends SnModel {
  @Expose() public id: string;
  @Expose() public organization: string;

  @Expose()
  @Type(() => SnTeam)
  public team: SnTeam;

  @Expose()
  @Type(() => SnUser)
  public user: SnUser;

  @Expose()
  @Type(() => SnNotificationGroup)
  public notificationGroup: SnNotificationGroup;

  @Expose() public keepDays: number;
  @Expose() public notifyDays: number;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
